/* Pilot-only display normalization. Never reads or changes cart/product state. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) {
    var boot = function () { api.init(root.document); };
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
    root.document.addEventListener('shopify:section:load', boot);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  function parseEuroCents(value, locale) {
    if (typeof value !== 'string') return null;
    var text = value.trim().replace(/[\u00a0\u202f]/g, ' ');
    if (!/^(?:\+\s*)?(?:€\s*)?\d[\d., ]*(?:\s*€)?$/.test(text) || (text.match(/€/g) || []).length > 1) return null;
    text = text.replace(/^\+\s*/, '').replace(/€/g, '').trim();
    var localeGroup;
    try {
      new Intl.NumberFormat(locale || 'nl').formatToParts(1234567.89).forEach(function (part) {
        if (part.type === 'group') localeGroup = part.value;
      });
    } catch (_) { return null; }
    var dots = (text.match(/\./g) || []).length;
    var commas = (text.match(/,/g) || []).length;
    var decimal = null;
    if (dots && commas) decimal = text.lastIndexOf('.') > text.lastIndexOf(',') ? '.' : ',';
    else if (dots || commas) {
      var separator = dots ? '.' : ',';
      var count = dots || commas;
      var tail = text.slice(text.lastIndexOf(separator) + 1);
      // FastBundle can retain its configured comma money format on an English
      // page. One/two trailing decimal digits are unambiguous for EUR prices.
      if (count === 1 && /^\d{1,2}$/.test(tail)) decimal = separator;
      else if (separator !== localeGroup && count === 1) return null;
    }
    var pieces = decimal ? text.split(decimal) : [text];
    if (pieces.length > 2 || (decimal && !/^\d{1,2}$/.test(pieces[1]))) return null;
    var integer = pieces[0];
    if (!/^\d+$/.test(integer)) {
      var groups = integer.split(/[., ]/);
      if (!/^\d{1,3}$/.test(groups[0]) || groups.slice(1).some(function (part) { return !/^\d{3}$/.test(part); })) return null;
      integer = groups.join('');
    }
    var cents = Number(integer) * 100 + Number((pieces[1] || '').padEnd(2, '0'));
    return Number.isSafeInteger(cents) && cents >= 0 && cents <= 1000000000000 ? cents : null;
  }
  function formatEuroPrice(value, locale) {
    var cents = parseEuroCents(value, locale);
    if (cents === null) return null;
    try {
      return '€' + new Intl.NumberFormat(locale || 'nl', {
        minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (_) { return null; }
  }
  function classPrefix(node, prefix) {
    return String(node.className || '').split(/\s+/).some(function (name) { return name.indexOf(prefix) === 0; });
  }
  function localizeBundleHeading(root, locale) {
    var language = String(locale || '').toLowerCase().split('-')[0];
    if (language !== 'nl' && language !== 'en' && language !== 'es' && language !== 'de' && language !== 'fr') return;
    var container = root.querySelector('#rbr-container-element-addOn');
    if (!container) return;
    container.querySelectorAll('span[class*="style_titleAndBadge_"]').forEach(function (heading) {
      if (!classPrefix(heading, 'style_titleAndBadge_') || heading.children.length) return;
      var current = heading.textContent.trim();
      if (current !== 'Vaak samen gekocht' && current !== 'Frequently bought together') return;
      var text = language === 'es' ? 'Comprados juntos con frecuencia' : (language === 'de' ? 'Häufig zusammen gekauft' : (language === 'fr' ? 'Souvent achetés ensemble' : (language === 'nl' ? 'Vaak samen gekocht' : 'Frequently bought together')));
      if (heading.textContent !== text) heading.textContent = text;
    });
  }
  function normalizePrices(root, locale) {
    if (root.getAttribute('data-currency') !== 'EUR') return;
    var container = root.querySelector('#rbr-container-element-addOn');
    if (!container) return;
    container.querySelectorAll('[class*="style_price_"]').forEach(function (price) {
      if (!classPrefix(price, 'style_price_')) return;
      Array.from(price.children).forEach(function (unit) {
        if (!classPrefix(unit, 'style_unitPrice_')) return;
        function candidates(parent) {
          return Array.from(parent.children).filter(function (node) {
            return node.tagName === 'SPAN' && !node.children.length && !String(node.className || '').trim() && !node.hidden && node.getAttribute('aria-hidden') !== 'true' && formatEuroPrice(node.textContent, locale) !== null;
          });
        }
        var numbers = candidates(unit);
        if (!numbers.length) numbers = candidates(price);
        if (numbers.length !== 1) return; // Unknown app markup must remain intact.
        var amount = numbers[0];
        var formatted = formatEuroPrice(amount.textContent, locale);
        if (amount.textContent !== formatted) amount.textContent = formatted;
        // Keep React's nodes and the visually hidden price label intact. Only
        // clear the standalone visible plus prefix, never any numeric/data field.
        Array.from(unit.childNodes).forEach(function (node) {
          if (node.nodeType === 3 && /^\s*\+\s*$/.test(node.nodeValue)) node.nodeValue = '';
        });
      });
    });
  }
  function init(document) {
    var view = document.defaultView;
    if (!view) return;
    document.querySelectorAll('[data-nspire-pilot]').forEach(function (root) {
      if (root.__nspirePresentation) return;
      var frame = null;
      var disposed = false;
      var observed = new Set();
      var resize = typeof view.ResizeObserver === 'function' ? new view.ResizeObserver(schedule) : null;
      function setStyle(node, name, value) {
        if (node.style.getPropertyValue(name) !== value || node.style.getPropertyPriority(name) !== 'important') node.style.setProperty(name, value, 'important');
      }
      function matchIconHeights() {
        var next = new Set();
        root.querySelectorAll('.sternify-payment-icons').forEach(function (row) {
          var klarna = row.querySelector('.sternify-payment-icon-klarna');
          var ideal = row.querySelector('.sternify-payment-icon-ideal');
          if (!klarna || !ideal) return;
          next.add(klarna);
          var height = klarna.getBoundingClientRect().height;
          if (!Number.isFinite(height) || height <= 0) return;
          var target = Math.round(height * 1000) / 1000 + 'px';
          setStyle(ideal, 'height', target);
          var ratio = ideal.naturalWidth > 0 && ideal.naturalHeight > 0 ? ideal.naturalWidth / ideal.naturalHeight : 153 / 100;
          setStyle(ideal, 'width', Math.round(height * ratio * 1000) / 1000 + 'px');
          setStyle(ideal, 'flex', '0 0 auto');
          setStyle(ideal, 'min-height', '0');
          setStyle(ideal, 'max-height', 'none');
          setStyle(ideal, 'max-width', 'none');
          setStyle(ideal, 'flex-shrink', '0');
          setStyle(ideal, 'align-self', 'center');
        });
        if (resize) {
          observed.forEach(function (node) { if (!next.has(node)) resize.unobserve(node); });
          next.forEach(function (node) { if (!observed.has(node)) resize.observe(node); });
        }
        observed = next;
      }
      function update() {
        frame = null;
        if (disposed) return;
        if (!root.isConnected) { cleanup(); return; }
        var locale = root.getAttribute('lang') || document.documentElement.lang || 'nl';
        localizeBundleHeading(root, locale);
        normalizePrices(root, locale);
        matchIconHeights();
      }
      function schedule() {
        if (!disposed && frame === null) frame = view.requestAnimationFrame(update);
      }
      var observer = typeof view.MutationObserver === 'function' ? new view.MutationObserver(schedule) : null;
      function unload(event) {
        if (!root.isConnected || (event.target && typeof event.target.contains === 'function' && event.target.contains(root))) cleanup();
      }
      function cleanup() {
        if (disposed) return;
        disposed = true;
        if (frame !== null) view.cancelAnimationFrame(frame);
        if (observer) observer.disconnect();
        if (resize) resize.disconnect();
        root.removeEventListener('load', schedule, true);
        view.removeEventListener('resize', schedule);
        document.removeEventListener('shopify:section:unload', unload);
        delete root.__nspirePresentation;
      }
      root.__nspirePresentation = { cleanup: cleanup };
      if (observer) observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'src', 'hidden', 'data-currency', 'lang'] });
      root.addEventListener('load', schedule, true);
      view.addEventListener('resize', schedule);
      document.addEventListener('shopify:section:unload', unload);
      schedule();
    });
  }
  return { init: init, parseEuroCents: parseEuroCents, formatEuroPrice: formatEuroPrice, normalizePrices: normalizePrices, localizeBundleHeading: localizeBundleHeading };
});


